import { Injectable, Type } from "@angular/core";
import { Routes } from "@angular/router";
import { DynamicRoute, IDynamicRoutesProvider } from "core";
import { PRICELISTS_DESCRIBE } from "../constants";
import { Pricelists } from "../pricelists/pricelists"
import { PricelistsList } from "../pricelists-list/pricelists-list"
import { PricelistsDetail } from "../pricelists-detail/pricelists-detail"

@Injectable({ providedIn: 'root' })
export class PricelistsRoutesProvider extends IDynamicRoutesProvider {

    override componentMap: Record<string, Type<any>> = {
        'pricelists': Pricelists,
        'pricelists-list': PricelistsList,
        'pricelists-detail': PricelistsDetail,
    };

    // deve corrispondere all'id nel json della chiamate delle rotte
    override describe(): String {
        return 'pricelists';
    }

    override evaluate(dynamicRoute: DynamicRoute[]): Routes {
        return this.buildRoutes(dynamicRoute, PRICELISTS_DESCRIBE);
    }
}